<template>
    <div class="DistributionListEditor">
        <div>
            <table class="table-utility">
                <thead>
                    <tr>
                        <th>List</th>
                        <th>Description</th>
                        <th>Recipients</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dl in DistributionListObjects">
                        <td>
                            {{dl.Name}} <br />
                            <button @click="ShowEdit(dl)" class="form-control modal-btn-row btn-primary" style="margin-top:5px;">EDIT</button>
                            <button @click="SendTestEmail(dl)" class="form-control modal-btn-row btn-secondary" style="margin-top:5px;">TEST EMAIL</button>
                        </td>
                        <td v-html="dl.Description"></td>
                        <td>
                            <p v-for="email in dl.RecipientArray">{{email}}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <b-modal ref="component-modal" title="Edit Distribution List" hide-footer>
            <b-container fluid>
                <b-form @submit="EditDistributionList" v-if="Object.keys(TargetDL).length != 0">
                    <b-row>
                        <div class="form-group">
                            <label>List Name:</label>
                            <p>{{TargetDL.Name}}</p>
                        </div>
                    </b-row>
                    <b-row>
                        <div class="form-group">
                            <label>Description:</label>
                            <p v-html="TargetDL.Description"></p>
                        </div>
                    </b-row>
                    <b-row>
                        <div class="form-group">
                            <label>Description:</label>
                            <textarea rows="6" v-model="TargetDL.Recipients" class="form-control"></textarea>
                        </div>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEdit()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components

    export default {
        name: "DistributionListEditor",
        props: [
            "SubProgramId"
        ],
        data: function () {
            return {
                DistributionListObjects: [],
                TargetDL: {}
            };
        },
        methods: {
            //FORM CONTROLS
            ShowEdit(dl) {
                this.TargetDL = JSON.parse(JSON.stringify(dl));
                this.$refs['component-modal'].show();
            },
            CancelEdit() {
                this.$refs['component-modal'].hide();
            },
            //API
            GetDistributionLists() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/SubProgramSettings/DistributionList", { Id: this.SubProgramId }, this.GetDistributionListsSuccess, () => { }, true);
            },
            GetDistributionListsSuccess(response) {
                this.DistributionListObjects = response.data.data;
            },
            EditDistributionList(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PUT", "Core/SubProgramSettings/DistributionList", { Id: this.TargetDL.Id, Recipients: this.TargetDL.Recipients }, this.EditDistributionListSuccess, () => { }, true);
            },
            EditDistributionListSuccess(response) {
                this.DistributionListObjects.forEach(function (i) {
                    if (i.Id == response.data.data.Id) {
                        i.Recipients = response.data.data.Recipients;
                        i.RecipientArray = response.data.data.RecipientArray;
                    }
                });
                this.$refs['component-modal'].hide();
            },
            SendTestEmail(dl) {
                this.$MasterAPI.ExecuteRequest("POST", "Core/SubProgramSettings/DistributionList/Test", { Id: dl.Id }, this.SendTestEmailSuccess, () => { }, true);
            },
            SendTestEmailSuccess(response) {
                alert("Test email sent successfully.  Check Email to confirm recipients received the test email.");
            }
        },
        computed: {

        },
        components: {
            
        },
        mounted() {
            this.GetDistributionLists();
        }
    }
</script>

<style scoped>
</style>